"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PutProjectConfigKeyModalComponent = void 0;
const React = __importStar(require("react"));
const react_1 = require("react");
const antd_1 = require("antd");
const Form_1 = require("antd/lib/form/Form");
const promiseUtils_1 = require("src/configeek_assets/src/system/mics/promiseUtils");
const ICCanisterUtils_1 = require("src/configeek_assets/src/ic/ICCanisterUtils");
const ProjectConfigStoreDataProvider_1 = require("src/configeek_assets/src/components/common/provider/ProjectConfigStoreDataProvider");
const lodash_1 = __importDefault(require("lodash"));
const use_custom_compare_1 = require("use-custom-compare");
const i18_1 = require("src/configeek_assets/src/i18");
const Analytics_1 = require("src/configeek_assets/src/system/analytics/Analytics");
const limits_1 = require("src/configeek_assets/src/limits");
const react_dom_1 = require("react-dom");
const jsonUtils_1 = require("src/configeek_assets/src/system/mics/jsonUtils");
const modalButtonsPropsInitialValue = {
    ok: { disabled: true },
    cancel: {}
};
const PutProjectConfigKeyModalComponent = (props) => {
    var _a;
    const isCreate = props.configKeyValuePair == undefined;
    const projectConfigStoreDataContext = (0, ProjectConfigStoreDataProvider_1.useProjectConfigStoreDataContext)();
    const existingConfigKeyValuePairs = ((_a = projectConfigStoreDataContext.config.data) === null || _a === void 0 ? void 0 : _a.configKeys) || [];
    const initialValues = props.configKeyValuePair ? lodash_1.default.cloneDeep(props.configKeyValuePair) : {
        key: "",
        value: ""
    };
    const [formValueKey, setFormValueKey] = (0, react_1.useState)(initialValues.key);
    const [formValueValue, setFormValueValue] = (0, react_1.useState)(initialValues.value);
    const [form] = (0, Form_1.useForm)();
    const [modalButtonProps, setModalButtonProps] = (0, react_1.useReducer)((state, newState) => ({ ...state, ...newState }), modalButtonsPropsInitialValue);
    const formRules = (0, use_custom_compare_1.useCustomCompareMemo)(() => {
        const parameterKeyRules = [{ required: true, message: "Key is required", max: limits_1.PARAMETER_KEY_MAXLENGTH, }];
        const parameterValueRules = [
            { message: `The maximum length of parameter value is ${limits_1.PARAMETER_VALUE_MAXLENGTH} characters`, max: limits_1.PARAMETER_VALUE_MAXLENGTH },
        ];
        if (isCreate) {
            parameterKeyRules.push({
                validator: (rule, value) => {
                    if (lodash_1.default.some(existingConfigKeyValuePairs, v => {
                        return v.key === value;
                    })) {
                        return Promise.reject(new Error("Parameter keys must be unique"));
                    }
                    return Promise.resolve();
                }
            });
        }
        return {
            key: parameterKeyRules,
            value: parameterValueRules,
        };
    }, [existingConfigKeyValuePairs, isCreate], lodash_1.default.isEqual);
    const title = isCreate ? `Add` : "Change Parameter";
    const okText = isCreate ? "Add" : "Change";
    const errorText = isCreate ? i18_1.i18.project.configuration.error.modal.create : i18_1.i18.project.configuration.error.modal.edit;
    const putCancellable = (0, react_1.useMemo)(() => (0, promiseUtils_1.makeCancelableAsync)(async (key, value) => {
        const putConfigKeyResult = await projectConfigStoreDataContext.putConfigKey(key, value);
        if (putConfigKeyResult.status === "success") {
            if (isCreate) {
                Analytics_1.Analytics.trackCreateParameter();
            }
            else {
                Analytics_1.Analytics.trackEditParameter();
            }
            await projectConfigStoreDataContext.fetchConfig();
        }
        return putConfigKeyResult;
    }), [projectConfigStoreDataContext.putConfigKey, projectConfigStoreDataContext.fetchConfig, isCreate]);
    const asyncPutKey = async (formValues) => {
        try {
            const { key, value } = formValues;
            //disabled buttons
            setModalButtonProps({
                ok: { disabled: true, loading: true, },
                cancel: { disabled: true, }
            });
            const result = await putCancellable.run(key, value);
            switch (result.state) {
                case "success": {
                    const putConfKeyResult = result.result;
                    // console.log("asyncPutKey putCancellable result", putConfKeyResult);
                    switch (putConfKeyResult.status) {
                        case "success": {
                            props.onDestroy();
                            break;
                        }
                        case "error": {
                            const reason = putConfKeyResult.reason;
                            const fieldName = !isCreate || reason == "keyValueTooLong" ? "value" : "key";
                            //enabled buttons
                            setModalButtonProps({
                                ok: { disabled: false, loading: false, },
                                cancel: { disabled: false, }
                            });
                            //update errors
                            form && form.setFields([{ name: fieldName, errors: [errorText] }]);
                            break;
                        }
                        case "unknownError": {
                            throw putConfKeyResult.error;
                        }
                    }
                    break;
                }
                case "cancelled": {
                    //skip
                    break;
                }
                case "error": {
                    // noinspection ExceptionCaughtLocallyJS
                    throw result.error;
                }
            }
        }
        catch (e) {
            const error = ICCanisterUtils_1.ICRestError.withUnknownError(e);
            console.error("ProjectConfigKeyModalComponent: putConfigKey failed", error);
            //enabled buttons
            setModalButtonProps({
                ok: { disabled: false, loading: false, },
                cancel: { disabled: false, }
            });
            const fieldName = isCreate ? "key" : "value";
            //update errors
            form && form.setFields([{ name: fieldName, errors: [errorText] }]);
        }
    };
    const onFormFieldsChange = (changedFields, allFields) => {
        let valid = true;
        for (const idx in allFields) {
            const field = allFields[idx];
            // console.log("onFormFieldsChange: field", field);
            if (field.errors && field.errors.length > 0) {
                // console.log("onFormFieldsChange: error in field", field);
                valid = false;
            }
        }
        let okButtonDisabled = !valid;
        const formValueFieldKey = form.getFieldValue("key") || "";
        const formValueFieldValue = form.getFieldValue("value") || "";
        if (!isCreate && !okButtonDisabled && formValueFieldValue === initialValues.value) {
            okButtonDisabled = true;
        }
        (0, react_dom_1.unstable_batchedUpdates)(() => {
            setModalButtonProps({
                ok: { disabled: okButtonDisabled }
            });
            setFormValueKey(formValueFieldKey);
            setFormValueValue(formValueFieldValue);
        });
    };
    const onFormFinish = async (values) => {
        // console.log("onFormFinish", values);
        await asyncPutKey(values);
    };
    const onCancel = () => {
        props.onDestroy();
    };
    const onOk = async () => {
        // console.log("onOk");
        if (form) {
            try {
                const values = await form.validateFields();
                await onFormFinish(values);
            }
            catch (info) {
                // console.log('Validate Failed:', info);
            }
        }
    };
    const formatMenuItems = (0, react_1.useMemo)(() => [
        {
            key: "json",
            label: "JSON",
            disabled: true
        },
        {
            type: "divider"
        },
        {
            key: "checkJSON",
            label: "Validate",
            onClick: () => {
                if (jsonUtils_1.JSONUtils.isJSONValid(formValueValue)) {
                    antd_1.message.success("JSON is valid!");
                }
                else {
                    antd_1.message.error("Not a valid JSON");
                }
            }
        },
        {
            key: "minifyJSON",
            label: "Minify",
            onClick: () => {
                if (jsonUtils_1.JSONUtils.isJSONValid(formValueValue)) {
                    if (form) {
                        form.setFields([{ name: "value", value: jsonUtils_1.JSONUtils.minifyJSON(formValueValue) }]);
                        form.validateFields();
                    }
                }
                else {
                    antd_1.message.error("Not a valid JSON");
                }
            }
        },
        {
            key: "beautifyJSON",
            label: "Beautify",
            onClick: () => {
                if (jsonUtils_1.JSONUtils.isJSONValid(formValueValue)) {
                    if (form) {
                        form.setFields([{ name: "value", value: jsonUtils_1.JSONUtils.beautifyJSON(formValueValue) }]);
                        form.validateFields();
                    }
                }
                else {
                    antd_1.message.error("Not a valid JSON");
                }
            }
        },
    ], [formValueValue, form]);
    const formatMenu = React.createElement(antd_1.Menu, { items: formatMenuItems, defaultOpenKeys: ["json"] });
    const actionsComponent = React.createElement(antd_1.Dropdown, { key: "actions", overlay: formatMenu, trigger: ["click"], placement: "top", disabled: modalButtonProps.cancel.disabled },
        React.createElement(antd_1.Button, { key: "actions" }, "Formatters"));
    const footer = [
        props.canEdit ? React.createElement(antd_1.Row, { key: "row", style: { marginTop: 10 } },
            React.createElement(antd_1.Col, null, actionsComponent),
            React.createElement(antd_1.Col, { flex: "auto" },
                React.createElement(antd_1.Button, { key: "cancel", onClick: onCancel, ...modalButtonProps.cancel }, "Cancel"),
                React.createElement(antd_1.Button, { key: "ok", onClick: onOk, type: "primary", ...modalButtonProps.ok }, okText))) : React.createElement(antd_1.Row, { key: "row", style: { marginTop: 10 } },
            React.createElement(antd_1.Col, { flex: "auto" },
                React.createElement(antd_1.Button, { key: "cancel", onClick: onCancel, ...modalButtonProps.cancel }, "Close"))),
    ];
    return React.createElement(antd_1.Modal, { width: 900, footer: footer, closable: false, maskClosable: false, destroyOnClose: true, visible: props.visible, title: title, onCancel: onCancel, className: "ug-modal" },
        React.createElement(antd_1.Form, { form: form, layout: "vertical", requiredMark: false, initialValues: initialValues, onFinish: onFormFinish, onFieldsChange: onFormFieldsChange },
            React.createElement(antd_1.Form.Item, { name: "key", label: "Key", rules: formRules.key },
                React.createElement(antd_1.Input, { autoFocus: true, maxLength: limits_1.PARAMETER_KEY_MAXLENGTH, disabled: !isCreate })),
            React.createElement(antd_1.Form.Item, { name: "value", label: "Value", rules: formRules.value },
                React.createElement(antd_1.Input.TextArea, { rows: 15, showCount: true, disabled: !props.canEdit }))));
};
exports.PutProjectConfigKeyModalComponent = PutProjectConfigKeyModalComponent;
const textAreaProps = {
    formatter: (args) => {
        return "";
    }
};
/*
aslkjahfdlkjahsdlkajhdflkajshdflkajshdaslkjahfdlkjahsdlkajhdflkajshdflkajshdaslkjahfdlkjahsdlkajhdflkajshdflkajshaslkjahfdlkj123
*/
